export default __webpack_public_path__ + "static/media/s12.6b6b2874.jpg";